import {useEffect, useState} from 'react';

import {customFetch} from '../utils/fetch';

const useFetch = ({url, initialData, getFormattedData = null, headers, domain}) => {
  const [state, setState] = useState({
    data: initialData,
    isLoading: true
  });

  useEffect(async() => {
    try {
      const newData = await customFetch({url, headers, domain});

      setState(prevState => ({
        ...prevState,
        data: getFormattedData ? getFormattedData(newData) : newData
      }));
    } catch (e) {
      console.error(e);
    } finally {
      setState(prevState => ({...prevState, isLoading: false}));
    }
  }, []);

  return state;
};

export default useFetch;
